export default () => {
  // function contents go here
};
